<div *ngIf="refreshCoverageToggle">
  <app-dynamic-form *ngIf="refreshBasePlanToggle" [baseDOName]="configData.StateToDOMapper[transactionState]"
    [(fetchingFormData)]="fetchingFormData"
    FORMTITLE="Base Plan" FORMNAME="BaseProductForm" [IO]="_inputDataForEdit"
    [currentComponentName]="'BasePlanComponent'" [(ngModel)]="basePlanComponentData['BasePlanComponent']"
    [ExtractElementFromArray]="'true'" [maxDepth]="'4'"
    [extractFromDOCoverage]="true"
    [formMetaData]="configData.ComponentMetaDataConfiguration.BasePlanComponent">
  </app-dynamic-form>
  <div class="text-a-right m-t-b-15">
    <nz-radio-group [(ngModel)]="coverageView" [nzButtonStyle]="'solid'">
      <label nz-radio-button nzValue="panelView">Panel View</label>
      <label nz-radio-button nzValue="treeView">Tree View</label>
    </nz-radio-group>
  </div>
  <div *ngIf="coverageView == 'treeView'">
    <div *ngIf="nodes.length > 0" class="config-grid m-t-30">
      <div class="treeSection" style="height: 500px;">
          <nz-tree [nzData]="nodes" nzCheckable 
            [nzCheckedKeys]="chosenBenefitsList"
            [nzSelectedKeys]="selectedCoverageListForTree"
            [nzExpandedKeys]="expandChosenBenefitsList" 
            (nzExpandChange)="expandBenefit($event)" (nzCheckBoxChange)="checkBenefit($event)" (nzClick)="chooseBenefit($event)">
          </nz-tree>
      </div>
      <ng-container *ngTemplateOutlet="componentRenderer"></ng-container>
    </div>

    <ng-template #componentRenderer>
      <ng-container *ngIf="mandatoryCoverageObjList && mandatoryCoverageObjList.length > 0" >
        <div *ngFor="let coverage of mandatoryCoverageObjList;let index = index;let first = first;" >
          <div [hidden]="!(coverage.riderCd == selectedCoverageFromTree)">
            <h3 class="heading">{{coverage.riderCd | technicalTranslate}}</h3>
            <app-dynamic-form *ngIf="coverage.uiConfigurations && coverage.uiConfigurations.length > 0" 
                  [baseDOName]="configData.StateToDOMapper[transactionState]"
                  [FORMNAME]="'MandatoryCoverageForm' + index" 
                  [(fetchingFormData)]="fetchingFormData"
                  [IO]="inputDataForEdit"
                  [currentComponentName]="'MandatoryCoveragesComponent'" 
                  [(ngModel)]="mandatoryCoverageComponentData[index]"
                  [ExtractElementFromArray]="'true'" 
                  [formMetaData]="coverage.uiConfigurations" 
                  [lookupLoadingMode]="'byData'">
                </app-dynamic-form>
            </div>
        </div>
      </ng-container>
  
      <ng-container *ngIf="additionalCoverageObjList && additionalCoverageObjList.length > 0" >
        <div *ngFor="let coverage of additionalCoverageObjList;let index = index;let first = first;">
          <div [hidden]="!(coverage.riderCd == selectedCoverageFromTree)">
            <h3 class="heading">{{coverage.riderCd | technicalTranslate}}</h3>
            <app-dynamic-form *ngIf="coverage.uiConfigurations && coverage.uiConfigurations.length > 0" 
              [baseDOName]="configData.StateToDOMapper[transactionState]"
              [FORMNAME]="'AdditionalCoverageForm'+ index" 
              [(fetchingFormData)]="fetchingFormData"
              [IO]="inputDataForEdit"
              [currentComponentName]="'AdditionalCoveragesComponent'" 
              [(ngModel)]="additionalCoveragesComponentData[index]"
              [ExtractElementFromArray]="'true'"  
              [formMetaData]="coverage.uiConfigurations"
              [lookupLoadingMode]="'byData'">
            </app-dynamic-form>
          </div>
        </div>
      </ng-container>
      <div *ngIf="!selectedCoverageFromTree">
        <nz-alert
          nzType="info"
          nzMessage="Guide:"
          nzDescription="Please click on the coverage name from let-side tree to see the available configuration."
          nzShowIcon
        ></nz-alert>
      </div>  
    </ng-template>
  </div>

  <div *ngIf="coverageView == 'panelView'">
    <nz-switch [ngModel]="true" nzCheckedChildren="Collapse All" 
        nzUnCheckedChildren="Expand All" 
        (ngModelChange)="expandCollapsePanel($event)">
    </nz-switch>
    <div *ngIf="mandatoryCoverageObjList.length > 0" class="heading-tab panel-custom-unified-collapse-heading m-t-30 m-b-15">
      <h3 class="heading">
        <em nz-icon nzType="profile"></em> Mandatory Coverages
      </h3>
    </div>
    <nz-collapse *ngIf="mandatoryCoverageObjList.length > 0" class="m-t-20 coveragePanel">
      <nz-collapse-panel *ngFor="let coverage of mandatoryCoverageObjList;let index = index;let first = first;" 
        [nzHeader]="coverage.riderCd | technicalTranslate" [nzActive]="isExpand">
        <div>
          <div class="coveragePanelBody">
            <app-dynamic-form [baseDOName]="configData.StateToDOMapper[transactionState]"
              [FORMNAME]="'MandatoryCoverageForm' + index" [IO]="inputDataForEdit"
              [(fetchingFormData)]="fetchingFormData"
              [currentComponentName]="'MandatoryCoveragesComponent'" [(ngModel)]="mandatoryCoverageComponentData[index]"
              [ExtractElementFromArray]="'true'" [extractFromDOCoverage]="true"
              [formMetaData]="coverage.uiConfigurations" [lookupLoadingMode]="'byData'">
            </app-dynamic-form>
            
            <div style="height:200px; max-height:200px; overflow-y: auto;" 
              *ngIf="coverage.productRiderBenefitList && coverage.productRiderBenefitList.length > 0">
              <h5 class="heading">Benefits available with {{coverage.riderCd | technicalTranslate}}: </h5>
              <nz-list [nzDataSource]="coverage.productRiderBenefitList" [nzRenderItem]="benefitItems" [nzItemLayout]="'horizontal'" nzBordered="true">
                <ng-template #benefitItems let-item>
                  <nz-list-item>
                    <nz-list-item-meta
                      [nzTitle]="nzTitle"
                      [nzDescription]="item.benefitDesc">
                      <ng-template #nzTitle>
                        <h4> {{ item.benefitName }}</h4>
                      </ng-template>
                    </nz-list-item-meta>
                  </nz-list-item>
                </ng-template>
              </nz-list>
            </div>
          </div>
        </div>
      </nz-collapse-panel>
    </nz-collapse>

    <!-- <div class="heading-tab panel-custom-unified-collapse-heading m-t-30 m-b-15">
      <h3 class="heading">
        <em nz-icon nzType="profile"></em> Death/TPD Benefit
      </h3>
    </div>
    
    <div class="coveragePanelBody d-flex align-items-center tab-grid m-t-20">
      <label nz-checkbox [(ngModel)]="levelDeathTPD" class="checkbox-label">
        Level Death / TPD Benefit
      </label>
      <label nz-checkbox [(ngModel)]="increasingDeathTPD" class="checkbox-label m-l-40">
        Increasing Death / TPD Benefit
      </label>
    </div> -->

    <div *ngIf="additionalCoverageObjList.length > 0" class="heading-tab panel-custom-unified-collapse-heading m-t-30 m-b-15">
      <h3 class="heading">
        <em nz-icon nzType="profile"></em> Additional Coverages
      </h3>
    </div>
    <nz-collapse *ngIf="additionalCoverageObjList.length > 0" class="m-t-20 coveragePanel">
      <nz-collapse-panel *ngFor="let coverage of additionalCoverageObjList;let index = index;let first = first;" 
        [nzHeader]="coverage.riderCd | technicalTranslate" [nzActive]="isExpand"><!--[nzExtra]="selectCoverageTemplate"-->
        <div>
          <div class="coveragePanelBody">
            <app-dynamic-form [baseDOName]="configData.StateToDOMapper[transactionState]"
              [FORMNAME]="'AdditionalCoverageForm'+ index" [IO]="_inputDataForEdit"
              [(fetchingFormData)]="fetchingFormData"
              [currentComponentName]="'AdditionalCoveragesComponent'" [(ngModel)]="additionalCoveragesComponentData[index]"
              (ngModelChange)="setRider(coverage.riderCd, index)"
              [ExtractElementFromArray]="'true'" [extractFromDOCoverage]="true"
              [formMetaData]="coverage.uiConfigurations" [lookupLoadingMode]="'byData'">
            </app-dynamic-form>

            <div style="height:200px;max-height:200px; overflow-y: auto;" *ngIf="coverage.productRiderBenefitList && coverage.productRiderBenefitList.length > 0">
              <h5 class="heading">Benefits available with {{coverage.riderCd | technicalTranslate}}: </h5>
              <nz-list [nzDataSource]="coverage.productRiderBenefitList" [nzRenderItem]="benefitItems" [nzItemLayout]="'horizontal'" nzBordered="true">
                <ng-template #benefitItems let-item>
                  <nz-list-item>
                    <nz-list-item-meta
                      [nzTitle]="nzTitle"
                      [nzDescription]="item.benefitDesc">
                      <ng-template #nzTitle>
                        <h4> {{ item.benefitName }}</h4>
                      </ng-template>
                    </nz-list-item-meta>
                  </nz-list-item>
                </ng-template>
              </nz-list>
            </div>

          </div>
        </div>
      </nz-collapse-panel>
    </nz-collapse>
    <ng-template #selectCoverageTemplate>
      <label nz-checkbox [(ngModel)]="chooseAdditionalCov"></label>
    </ng-template>
  </div>
</div>